import React from "react";
import { Spinner } from "react-bootstrap";
import Div100vh from "react-div-100vh";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
const LoadingPage = React.memo(() => {
  const styles = useStyles();
  return (
    <Div100vh className={styles.loading}>
      <Spinner animation="border"></Spinner>
    </Div100vh>
  );
});

export { LoadingPage };
